import React from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap-5';

import pluralize from 'pluralize';
import type { CallList } from 'bundles/connect/types';
import CallListItemsTable from './call_list_items_table';
import Paginator from '../paginator';
import OffMarketMapTableViewToggle from 'bundles/connect/components/search/components/off_market_map_table_view_toggle';
import { useDispatch, useSelector } from 'react-redux';
import { selectCallListTableView, selectLoading } from '../store/selectors/ui';
import { selectPage, selectTotal, selectTotalPages } from '../store/selectors/results';
import { setPage } from '../store/actions/results';
import { formatWithCommas } from 'helpers/formatters/number_formats';

type CallListTableViewProps = {
  callList: CallList;
  lastUpdatedMap: Map<number, Date>;
}

export default function CallListTableView({ callList, lastUpdatedMap }: CallListTableViewProps) {
  const dispatch = useDispatch();
  const showTableView = useSelector(selectCallListTableView);
  const page = useSelector(selectPage);
  const totalPages = useSelector(selectTotalPages);
  const total = useSelector(selectTotal);
  const loading = useSelector(selectLoading);

  const handlePagination = (newPage: number) => {
    dispatch(setPage(newPage));
  };

  if (!showTableView) {
    return null;
  }

  return (
    <>
      <Card.Header className="border-top z-3 position-relative shadow-md p-3">
        <Row className="justify-content-between align-items-center">
          <Col>
            <strong>
              {loading ? (
                <div className="d-flex align-items-center">
                  <Spinner animation="border" size="sm" variant="secondary" />
                  <span className="ms-3">Loading...</span>
                </div>
              ) :
                (<>{formatWithCommas(total)} {pluralize('Property', total)}</>)
              }
            </strong>
          </Col>
          <Col xs="auto">
            <OffMarketMapTableViewToggle />
          </Col>
        </Row>
      </Card.Header>
      <CallListItemsTable
        callListId={callList.id}
        lastUpdatedMap={lastUpdatedMap}
      />
      <div
        className="px-3 py-4 d-flex justify-content-center position-sticky z-3 border-top bottom-0 bg-white"
        style={{ minHeight: 82 }}
      >
        {totalPages > 1 && (
          <Paginator currentPage={page} perPage={25} total={total} onSelect={handlePagination} />
        )}
      </div>
    </>
  );
}
